/**
 * Get bilingual field value based on current language.
 * Falls back to the other language, then to the legacy field.
 */
export function getBilingualValue(
  language: string,
  enValue?: string | null,
  zhValue?: string | null,
  fallback?: string | null
): string | null {
  if (language === 'zh') {
    return zhValue || enValue || fallback || null;
  }
  return enValue || zhValue || fallback || null;
}
